/*
 * File: d:\projects\AutoFiFront\src\Content\IntelBoard\IntelBoard.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Thursday April 6th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Thursday April 6th 2023 10:34:19 am
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import React from 'react';
import styles from 'Content/IntelBoard/IntelBoard.module.css';
import IntelBoardStyled from 'Theme/Component/IntelBoardStyled';
import HrStyled from 'Theme/Component/HrStyled';
import IntelBoardRow from 'Content/IntelBoard/IntelBoardRow';

type IntelBoardProps ={
    items:{item: string, value: number, unit: string}[],
    title: string,
    finalItem?: {item: string, value: number, unit: string},
    className?: string,
    bgColor?: string,
    border?: number
};

function IntelBoard(props: IntelBoardProps) {
    const myRows = props.items.map((item,index)=> {return <IntelBoardRow item={item.item} value={item.value} unit={item.unit} index={index} /> });

    return (
        <React.Fragment>
            <IntelBoardStyled bgColor={props.bgColor} border={props.border} >
                <div className={`${styles.intelBoard} ${props.className ? props.className : ""}`}>
                    <h3 className={`title`}>{props.title}</h3>
                    <div className={`${styles.resumePricing}`}>
                        {myRows}
                    </div>
                    <HrStyled bgColor={props.bgColor}/>
                    {
                        props.finalItem ? <div className={`${styles.finalItem}`}>
                                <h3>
                                    {props.finalItem?.item}
                                </h3>
                            <div className={`test`}>
                                <h3>
                                    {props.finalItem?.value}
                                    {props.finalItem?.unit}
                                </h3>
                            </div>
                        </div>
                        : null
                    }
                </div>
            </IntelBoardStyled>
        </React.Fragment>
    );
}

export default IntelBoard;
